;(function () {
  const sliderInstances = new WeakMap()
  const resizeObservers = new WeakMap()
  const arrowObservers = new WeakMap()
  const flowRafs = new WeakMap()
  const flowAnimated = new WeakSet()
  const flowAnimating = new WeakSet()

const FORWARD_MS = 1700
const REVERSE_DELAY_MS = 140
const REVERSE_MS = 1300


  const clamp01 = (n) => Math.max(0, Math.min(1, n))
  const easeOut = (t) => 1 - Math.pow(1 - clamp01(t), 3)

  const addClasses = (slider) => {
    const sliderWrapper = slider.querySelector('.multicolumn-list__wrapper')
    const slides = slider.querySelectorAll('.multicolumn-list__item')
    slider.classList.add('swiper')
    if (sliderWrapper) sliderWrapper.classList.add('swiper-wrapper')
    if (slides.length > 1) slides.forEach((slide) => slide.classList.add('swiper-slide'))
  }

  const removeClasses = (slider) => {
    const sliderWrapper = slider.querySelector('.multicolumn-list__wrapper')
    const slides = slider.querySelectorAll('.multicolumn-list__item')
    slider.classList.remove('swiper')
    if (sliderWrapper) sliderWrapper.classList.remove('swiper-wrapper')
    slides.forEach((slide) => {
      slide.removeAttribute('style')
      slide.classList.remove('swiper-slide')
    })
  }

  const initSlider = (section) => {
    const slider = section.querySelector('.swiper--multicolumn')
    if (!slider || sliderInstances.has(slider) || typeof Swiper === 'undefined') return

    addClasses(slider)
    const instance = new Swiper(slider, {
      loop: false,
      speed: 800,
      breakpoints: {
        320: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 16 },
        750: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 16 },
      },
      pagination: {
        el: slider.querySelector('.multicolumn__pagination'),
        clickable: true,
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          let out = ''
          for (let i = 1; i < total + 1; i++) {
            out +=
              i === current
                ? `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`
                : `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`
          }
          return out
        },
      },
    })
    sliderInstances.set(slider, instance)
  }

  const destroySlider = (section) => {
    const slider = section.querySelector('.swiper--multicolumn')
    if (!slider) return
    const instance = sliderInstances.get(slider)
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy(true, true)
      sliderInstances.delete(slider)
    }
    removeClasses(slider)
  }

  const disconnectArrowObserver = (section) => {
    const observer = arrowObservers.get(section)
    if (!observer) return
    observer.disconnect()
    arrowObservers.delete(section)
  }

  const getFlowEls = (section) => {
    const flowWrap = section.querySelector('.multicolumn-flow-arrows')
    if (!flowWrap) return null

    return {
      flowWrap,
      svg: flowWrap.querySelector('.multicolumn-flow-svg'),
      topPath: flowWrap.querySelector('.flow-path--top'),
      bottomPath: flowWrap.querySelector('.flow-path--bottom'),
      topReveal: flowWrap.querySelector('.flow-reveal--top'),
      bottomReveal: flowWrap.querySelector('.flow-reveal--bottom'),
      topHeadPath: flowWrap.querySelector('.flow-head-path--top'),
      bottomHeadPath: flowWrap.querySelector('.flow-head-path--bottom'),
      topForward: flowWrap.querySelector('.flow-travel-head--top-forward'),
      topReverse: flowWrap.querySelector('.flow-travel-head--top-reverse'),
      bottomForward: flowWrap.querySelector('.flow-travel-head--bottom-forward'),
      bottomReverse: flowWrap.querySelector('.flow-travel-head--bottom-reverse'),
      maskBgs: flowWrap.querySelectorAll('.flow-mask-bg'),
    }
  }

  const setRevealProgress = (revealEl, progress) => {
    if (!revealEl) return
    const len = parseFloat(revealEl.dataset.pathLen || '0')
    if (!len) return
    revealEl.style.strokeDashoffset = `${len * (1 - clamp01(progress))}`
  }

  const hideTravelHeads = (els) => {
    ;[els.topForward, els.topReverse, els.bottomForward, els.bottomReverse].forEach((head) => {
      if (!head) return
      head.style.opacity = '0'
      head.removeAttribute('transform')
    })
  }

  const cancelFlowRaf = (section) => {
    const rafId = flowRafs.get(section)
    if (rafId) cancelAnimationFrame(rafId)
    flowRafs.delete(section)
  }

  const stopFlowAnimation = (section) => {
    cancelFlowRaf(section)
    const els = getFlowEls(section)
    if (els) hideTravelHeads(els)
    flowAnimating.delete(section)
  }

  const clearFlowArrows = (section) => {
    disconnectArrowObserver(section)
    stopFlowAnimation(section)
    flowAnimated.delete(section)

    const multicolumn = section.querySelector('.multicolumn')
    if (multicolumn) {
      multicolumn.classList.remove('flow-arrows-in-view')
      multicolumn.classList.remove('flow-heads-final')
    }

    const els = getFlowEls(section)
    if (!els) return

    ;[els.topPath, els.bottomPath, els.topReveal, els.bottomReveal, els.topHeadPath, els.bottomHeadPath].forEach((p) => {
      if (!p) return
      p.setAttribute('d', '')
      p.style.strokeDasharray = '0'
      p.style.strokeDashoffset = '0'
      delete p.dataset.pathLen
    })
  }

const setFlowGeometry = (section) => {
  const wrapper = section.querySelector('.multicolumn-list__wrapper')
  const els = getFlowEls(section)
  if (!wrapper || !els || window.innerWidth < 990) return false
  if (!els.svg || !els.topPath || !els.bottomPath || !els.topReveal || !els.bottomReveal || !els.topHeadPath || !els.bottomHeadPath) return false

  const cards = Array.from(wrapper.querySelectorAll('.multicolumn-list__item')).slice(0, 3)
  if (cards.length < 3) return false

  const firstRect = cards[0].getBoundingClientRect()
  const secondRect = cards[1].getBoundingClientRect()
  const thirdRect = cards[2].getBoundingClientRect()
  const flowRect = els.flowWrap.getBoundingClientRect()

  const svgWidth = Math.max(1, flowRect.width)
  const svgHeight = Math.max(1, flowRect.height)
  els.svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`)

  if (els.maskBgs && els.maskBgs.length) {
    els.maskBgs.forEach((r) => {
      r.setAttribute('x', '0')
      r.setAttribute('y', '0')
      r.setAttribute('width', `${svgWidth}`)
      r.setAttribute('height', `${svgHeight}`)
    })
  }

  const cornerInset = Math.max(20, Math.min(44, Math.min(firstRect.width, secondRect.width, thirdRect.width) * 0.16))
  const topBorderInsetY = -2
  const bottomBorderInsetY = 2

  // Top arc: 1 -> 2, just brushing top border
  const topStartX = firstRect.right - flowRect.left - cornerInset
  const topEndX = secondRect.left - flowRect.left + cornerInset
  const topStartY = firstRect.top - flowRect.top + topBorderInsetY
  const topEndY = secondRect.top - flowRect.top + topBorderInsetY
  const topLift = Math.max(30, (topEndX - topStartX) * 0.18)
  const topCurveY = Math.min(topStartY, topEndY) - topLift

  // Bottom arc: 1 -> 3, touching bottom border (not too low)
  const bottomStartX = firstRect.right - flowRect.left - cornerInset
  const bottomEndX = thirdRect.left - flowRect.left + cornerInset
  const bottomStartY = firstRect.bottom - flowRect.top + bottomBorderInsetY
  const bottomEndY = thirdRect.bottom - flowRect.top + bottomBorderInsetY
  const bottomDrop = Math.max(52, (bottomEndX - bottomStartX) * 0.12)
  const bottomCurveY = Math.max(bottomStartY, bottomEndY) + bottomDrop

  const topC1X = topStartX + (topEndX - topStartX) * 0.34
  const topC2X = topStartX + (topEndX - topStartX) * 0.72
  const bottomC1X = bottomStartX + (bottomEndX - bottomStartX) * 0.34
  const bottomC2X = bottomStartX + (bottomEndX - bottomStartX) * 0.7

  const topD = `M ${topStartX} ${topStartY} C ${topC1X} ${topCurveY}, ${topC2X} ${topCurveY}, ${topEndX} ${topEndY}`
  const bottomD = `M ${bottomStartX} ${bottomStartY} C ${bottomC1X} ${bottomCurveY}, ${bottomC2X} ${bottomCurveY}, ${bottomEndX} ${bottomEndY}`

  ;[els.topPath, els.topReveal, els.topHeadPath].forEach((p) => p.setAttribute('d', topD))
  ;[els.bottomPath, els.bottomReveal, els.bottomHeadPath].forEach((p) => p.setAttribute('d', bottomD))

  const topLen = Math.max(1, Math.ceil(els.topPath.getTotalLength()))
  const bottomLen = Math.max(1, Math.ceil(els.bottomPath.getTotalLength()))

  els.topReveal.dataset.pathLen = `${topLen}`
  els.bottomReveal.dataset.pathLen = `${bottomLen}`
  els.topReveal.style.setProperty('--path-len', `${topLen}`)
  els.bottomReveal.style.setProperty('--path-len', `${bottomLen}`)
  els.topReveal.style.strokeDasharray = `${topLen} ${topLen}`
  els.bottomReveal.style.strokeDasharray = `${bottomLen} ${bottomLen}`

  if (flowAnimated.has(section)) {
    setRevealProgress(els.topReveal, 1)
    setRevealProgress(els.bottomReveal, 1)
  } else {
    setRevealProgress(els.topReveal, 0)
    setRevealProgress(els.bottomReveal, 0)
  }

  return true
}

const placeTravelHead = (pathEl, headEl, progress, reverse) => {
  const len = pathEl.getTotalLength()
  if (!len) return

  const p = Math.max(0.001, Math.min(0.999, progress))
  const dist = reverse ? len * (1 - p) : len * p

  const delta = Math.min(16, len * 0.08)
  const sampleA = Math.max(0, Math.min(len, dist - delta))
  const sampleB = Math.max(0, Math.min(len, dist + delta))
  const a = pathEl.getPointAtLength(sampleA)
  const b = pathEl.getPointAtLength(sampleB)

  let angle = (Math.atan2(b.y - a.y, b.x - a.x) * 180) / Math.PI
  if (reverse) angle += 180

  const tipInset = reverse ? 5.0 : 3.0
  const tipDist = reverse ? Math.max(0, dist - tipInset) : Math.min(len, dist + tipInset)
  const tip = pathEl.getPointAtLength(tipDist)

  headEl.setAttribute('transform', `translate(${tip.x} ${tip.y}) rotate(${angle})`)
}

const showFinalTravelHeads = (els) => {
  placeTravelHead(els.topPath, els.topForward, 0.999, false)
  placeTravelHead(els.bottomPath, els.bottomForward, 0.999, false)
  placeTravelHead(els.topPath, els.topReverse, 0.999, true)
  placeTravelHead(els.bottomPath, els.bottomReverse, 0.999, true)
  els.topForward.style.opacity = '1'
  els.bottomForward.style.opacity = '1'
  els.topReverse.style.opacity = '1'
  els.bottomReverse.style.opacity = '1'
}


const runFlowAnimation = (section) => {
  const els = getFlowEls(section)
  const multicolumn = section.querySelector('.multicolumn')
  if (!els || !multicolumn) return
  if (flowAnimating.has(section)) return

  stopFlowAnimation(section)
  flowAnimating.add(section)

  multicolumn.classList.remove('flow-heads-final')
  multicolumn.classList.add('flow-arrows-in-view')
  setRevealProgress(els.topReveal, 0)
  setRevealProgress(els.bottomReveal, 0)
  hideTravelHeads(els)

  const reverseStart = FORWARD_MS + REVERSE_DELAY_MS
  const totalMs = reverseStart + REVERSE_MS
  const startedAt = performance.now()

  const frame = (now) => {
    const t = now - startedAt

    const forwardP = t <= FORWARD_MS ? easeOut(t / FORWARD_MS) : 1
    setRevealProgress(els.topReveal, forwardP)
    setRevealProgress(els.bottomReveal, forwardP)

    if (t <= FORWARD_MS) {
      placeTravelHead(els.topPath, els.topForward, forwardP, false)
      placeTravelHead(els.bottomPath, els.bottomForward, forwardP, false)
    } else {
      placeTravelHead(els.topPath, els.topForward, 0.999, false)
      placeTravelHead(els.bottomPath, els.bottomForward, 0.999, false)
    }
    els.topForward.style.opacity = '1'
    els.bottomForward.style.opacity = '1'

    if (t >= reverseStart && t <= totalMs) {
      const reverseP = easeOut((t - reverseStart) / REVERSE_MS)
      placeTravelHead(els.topPath, els.topReverse, reverseP, true)
      placeTravelHead(els.bottomPath, els.bottomReverse, reverseP, true)
      els.topReverse.style.opacity = '1'
      els.bottomReverse.style.opacity = '1'
    } else if (t < reverseStart) {
      els.topReverse.style.opacity = '0'
      els.bottomReverse.style.opacity = '0'
    }

    if (t < totalMs) {
      const rafId = requestAnimationFrame(frame)
      flowRafs.set(section, rafId)
      return
    }

    cancelFlowRaf(section)
    setRevealProgress(els.topReveal, 1)
    setRevealProgress(els.bottomReveal, 1)
    showFinalTravelHeads(els)
    flowAnimating.delete(section)
    flowAnimated.add(section)
  }

  const rafId = requestAnimationFrame(frame)
  flowRafs.set(section, rafId)
}


  const observeFlowAnimation = (section) => {
    if (flowAnimated.has(section) || flowAnimating.has(section) || arrowObservers.has(section)) return

    if (!('IntersectionObserver' in window)) {
      runFlowAnimation(section)
      return
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            runFlowAnimation(section)
            obs.disconnect()
            arrowObservers.delete(section)
          }
        })
      },
      { threshold: 0.35 }
    )

    observer.observe(section)
    arrowObservers.set(section, observer)
  }

  const syncSection = (section) => {
    if (!section || !section.classList || !section.classList.contains('multicolumn-section')) return

    if (section.clientWidth < 990) {
      initSlider(section)
      clearFlowArrows(section)
      return
    }

    destroySlider(section)

    const hasFlow = !!section.querySelector('.multicolumn-flow-arrows')
    if (!hasFlow) return

    const ok = setFlowGeometry(section)
    if (!ok) {
      clearFlowArrows(section)
      return
    }

    const multicolumn = section.querySelector('.multicolumn')
    const els = getFlowEls(section)

    if (flowAnimating.has(section)) {
      if (multicolumn) multicolumn.classList.add('flow-arrows-in-view')
      return
    }

if (flowAnimated.has(section)) {
  if (multicolumn) multicolumn.classList.add('flow-arrows-in-view')
  if (els) {
    setRevealProgress(els.topReveal, 1)
    setRevealProgress(els.bottomReveal, 1)
    showFinalTravelHeads(els)
  }
  cancelFlowRaf(section)
  flowAnimating.delete(section)
} else {
  observeFlowAnimation(section)
}

  }

  const initSection = (section) => {
    if (!section || !section.classList || !section.classList.contains('multicolumn-section')) return

    syncSection(section)
    window.requestAnimationFrame(() => syncSection(section))

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        window.requestAnimationFrame(() => syncSection(section))
      })
    }

    window.addEventListener(
      'load',
      () => {
        window.requestAnimationFrame(() => syncSection(section))
      },
      { once: true }
    )

    if (!resizeObservers.has(section) && 'ResizeObserver' in window) {
      const ro = new ResizeObserver(() => {
        window.requestAnimationFrame(() => syncSection(section))
      })
      ro.observe(section)
      resizeObservers.set(section, ro)
    }
  }

  const currentSection = document.currentScript && document.currentScript.parentElement
  if (currentSection) initSection(currentSection)

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target)
  })
})()
